import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

function browserPrefersSpanish() {
  const candidates = [
    ...(navigator.languages || []),
    navigator.language,
    navigator.userLanguage,
  ].filter(Boolean);
  return candidates.some((tag) => String(tag).toLowerCase().startsWith('es'));
}

function initialLanguage() {
  const saved = localStorage.getItem('preferred-language');
  if (saved === 'es' || saved === 'en') {
    return saved;
  }
  return browserPrefersSpanish() ? 'es' : 'en';
}

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(initialLanguage);

  useEffect(() => {
    localStorage.setItem('preferred-language', language);
    if (typeof document !== 'undefined') {
      document.documentElement.lang = language === 'es' ? 'es' : 'en';
    }
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'es' : 'en');
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    isSpanish: language === 'es',
    isEnglish: language === 'en'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}
